import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import VisibilitySensor from '../VisibilitySensor/VisibilitySensor';
import { FormattedMessage } from 'react-intl';
import config from '../../config';
import { getFileUrl } from '../../util/file';

export default class FileLoader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: null,
            isLoading: false,
            isLoaded: false,
            hasError: false,
            loadedUrls: {},
            isVisible: false,
        };
    }

    componentDidMount() {
        this.init();
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.filename !== this.props.filename) {
            this.init();
        }
    }

    init = () => {
        if(this.props.loadonmount) {
            this.handleLoadFile();
        }
    };

    handleVisibilityChange = isVisible => {
        this.setState({
            isVisible,
        }, () => {
            setTimeout(() => {
                if(this.state.isVisible && !this.state.isLoaded && !this.state.isLoading) {
                    this.handleLoadFile();
                }
            }, 200);
        });
    };

    handleLoadFile = () => {
        if(this.props.filename) {
            if(this.state.loadedUrls[this.props.filename]) {
                this.setState({
                    url: this.state.loadedUrls[this.props.filename],
                    isLoaded: true,
                });
            } else {
                this.setState({
                    isLoading: true,
                });
                getFileUrl(this.props.filename, this.props.owner, null, true).then(url => {
                    this.setState({
                        url,
                        isLoading: false,
                        isLoaded: true,
                        loadedUrls: {
                            ...this.state.loadedUrls,
                            [this.props.filename]: url,
                        },
                    });
                }).catch(err => {
                    console.error('FileLoader::: Error', err);
                    this.setState({
                        isLoading: false,
                        hasError: true,
                    });
                });
            }
        }
    };

    renderFileTag() {
        if(this.props.filename) {
            const { url, filename, loadonmount, hidePlaceholders, owner, ...nativeProps } = this.props;
            const finalUrl = url || this.state.url;
            const ext = filename.split('.').pop();
            switch(ext.toLowerCase()) {
                case 'jpg':
                case 'jpeg':
                case 'gif':
                case 'png':
                case 'tiff':
                case 'bmp':
                case 'svg':
                    return <img src={finalUrl} {...nativeProps} />; // eslint-disable-line

                case 'mp3':
                case 'wav':
                case 'ogg':
                case 'oga':
                case 'm4a':
                case 'aac':
                    return <audio src={finalUrl} controls className="w-100" {...nativeProps} />; // eslint-disable-line

                default:
                    return <a href={finalUrl} download={filename.split('/').pop()} target="_blank"><FontAwesomeIcon icon="download" /> {filename.split('/').pop()}</a>; // eslint-disable-line
            }
        }
    }

    renderPendingFile() {
        if(this.props.hidePlaceholders) {
            return <span>&nbsp;</span>;
        }
        return (
            this.state.isLoading
            ? <FontAwesomeIcon icon="spinner" spin className="m-3" />
            : <FontAwesomeIcon icon="file-image" className="m-3" />
        );
    }

    render() {
        if(this.props.filename) {
            if(this.props.url) {
                return this.renderFileTag();
            }

            if(this.state.hasError) {
                return (
                    <small className="text-danger">
                        <em>
                            <FontAwesomeIcon icon="exclamation-triangle" /> <FormattedMessage id="fileFetchErrorText" defaultMessage="File not found!" />
                        </em>
                    </small>
                );
            }

            return (
                <VisibilitySensor onChange={this.handleVisibilityChange}>
                    {
                        this.state.isLoaded
                        ? this.renderFileTag()
                        : this.renderPendingFile()
                    }
                </VisibilitySensor>
            );
        }
        return null;
    }
}

FileLoader.defaultProps = {
    owner: '',
    loadonmount: false,
    hidePlaceholders: false,
    url: null,
};

FileLoader.propTypes = {
    filename: PropTypes.string.isRequired,
    owner: PropTypes.string,
    loadonmount: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    hidePlaceholders: PropTypes.bool,
    url: PropTypes.string,
};
